document.addEventListener('DOMContentLoaded',function(){
  var nav=document.querySelector('.mf-guaranteed-nav');
  if(!nav)return;
  var mobile=nav.querySelector('#mf-guaranteed-mobile');
  var mobileBtn=nav.querySelector('.mf-guaranteed-nav__mobile-btn');

  if(mobileBtn&&mobile){
    mobileBtn.addEventListener('click',function(){
      var isOpen=!mobile.hasAttribute('hidden');
      if(isOpen){
        mobile.setAttribute('hidden','');
        mobileBtn.setAttribute('aria-expanded','false');
      }else{
        mobile.removeAttribute('hidden');
        mobileBtn.setAttribute('aria-expanded','true');
      }
    });
  }

  nav.querySelectorAll('.mf-guaranteed-nav__dropbtn,.mf-guaranteed-nav__subbtn').forEach(function(btn){
    btn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      var item=btn.parentElement;
      var open=item.classList.contains('is-open');
      item.parentElement.querySelectorAll(':scope > .is-open').forEach(function(el){
        el.classList.remove('is-open');
        var b=el.querySelector(':scope > .mf-guaranteed-nav__dropbtn,:scope > .mf-guaranteed-nav__subbtn');
        if(b)b.setAttribute('aria-expanded','false');
      });
      if(!open){
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded','true');
      }
    });
  });

  document.addEventListener('click',function(e){
    if(!nav.contains(e.target)){
      nav.querySelectorAll('.is-open').forEach(function(el){el.classList.remove('is-open')});
      nav.querySelectorAll('[aria-expanded="true"]').forEach(function(el){el.setAttribute('aria-expanded','false')});
      if(mobile&&!mobile.hasAttribute('hidden'))mobile.setAttribute('hidden','');
      if(mobileBtn)mobileBtn.setAttribute('aria-expanded','false');
    }
  });
});